import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { heroSlides, siteInfo } from '../mock';

const HeroSection = ({ setActiveSection }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % heroSlides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  };

  return (
    <div id="home" className="relative h-[600px] md:h-[700px] overflow-hidden">

      {heroSlides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? 'opacity-100' : 'opacity-0'
            }`}
        >
          <div className="absolute inset-0">
            <img
              src={slide.image}
              alt={slide.title}
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
          </div>

          <div className="relative h-full container mx-auto px-4 flex items-center">
            <div className="max-w-2xl text-white">
              <p className="text-amber-400 text-lg md:text-xl mb-4 font-light">{siteInfo.name}</p>
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-6 leading-tight">
                {slide.title}
              </h1>
              <p className="text-xl md:text-2xl mb-8 text-amber-300">{slide.subtitle}</p>

              <div className="flex flex-col sm:flex-row gap-4">

                {/* 🔥 FIXED BUTTON → NO SCROLL, NO ERROR */}
                <button
                  onClick={() => setActiveSection("booking")}
                  className="bg-amber-900 text-white px-8 py-4 rounded-md hover:bg-amber-800 transition-all hover:scale-105 font-medium text-lg"
                >
                  Book Now
                </button>

                <a
                  href={`tel:${siteInfo.phone}`}
                  className="border-2 border-white text-white px-8 py-4 rounded-md hover:bg-white hover:text-amber-900 transition-all hover:scale-105 font-medium text-lg text-center"
                >
                  {siteInfo.phone}
                </a>
              </div>

            </div>
          </div>
        </div>
      ))}

      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-black/20 hover:bg-white/40 backdrop-sm text-white p-3 rounded-full transition-all"
      >
        <ChevronLeft size={24} />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-black/20 hover:bg-white/40 backdrop-sm text-white p-3 rounded-full transition-all"
      >
        <ChevronRight size={24} />
      </button>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex gap-3">
        {heroSlides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrentSlide(index)}
            className={`w-3 h-3 rounded-full transition-all ${index === currentSlide ? 'bg-amber-400 w-8' : 'bg-black/50'
              }`}
          />
        ))}
      </div>
    </div>
  );
};

export default HeroSection;
